import React from "react";
import PropTypes from 'prop-types';
import DropdownSelect from "./DropdownSelect";

const DropDown = ({
  keyId,
  placeholder,
  isMultiSelect = false,
  options,
  value,
  onChange,
  onBlur,
  isDisabled = false,
  inputInfoConfig,
  isLoading = false,
  className = "d-inline-block custom-input",
}) => {

  const defaultSelectedOption = value ? options?.find(option => option.value === value) : null;

  const defaultSelectedOptionMultiSelect = Array.isArray(value) ?
    options.filter(option => value.includes(option.value)) : [];

  return (
    <span className={className}>
      <DropdownSelect
        keyId={keyId}
        placeholder={placeholder}
        isMultiSelect={isMultiSelect}
        optionsValue={options}
        value={isMultiSelect ? defaultSelectedOptionMultiSelect : defaultSelectedOption}
        handleDropdownChange={onChange}
        handleDropdownBlur={onBlur}
        isDropdownDisabled={isDisabled}
        inputInfoConfig={inputInfoConfig}
        isLoading={isLoading}
      />
    </span>
  );
};

DropDown.propTypes = {
  keyId: PropTypes.string,
  placeholder: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  inputInfoConfig: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
};

DropDown.defaultProps = {
  isMultiSelect: false,
  isDisabled: false,
  className: "d-inline-block custom-input",
};

export default DropDown;
